// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Prompt } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeletePrompt(): (promptId: string) => Promise<Prompt> {
  const getAPI = useGetApi();
  return useCallback(
    async (promptId) => (await getAPI()).prompts.deletePrompt({ promptId }),
    [getAPI]
  );
}
